import React from "react";

import { Input } from "../../../common/u1/Input";
import { SelectField } from "../../../common/u1/SelectField";
import { CountrySelect } from "../../../common/u1/CountrySelect";
import { EditDialog } from "./EditDialog";
import { CompanySearchField } from "./CompanySearchField";
import { useRelationForm } from "./useRelationForm";

/* Add / edit a related entity or a business relation — one dialog for both. */
export const RelationFormModal = ({ spec, editing, chosen, onChoose, onClose, onSaved }) => {
  const {
    companyName,
    companyLocked,
    relationType,
    setRelationType,
    state,
    setState,
    country,
    setCountry,
    errors,
    setErrors,
    busy,
    submit,
  } = useRelationForm(spec, { editing, chosen, onSaved });

  return (
    <EditDialog
      title={editing ? spec.dialogEdit : spec.dialogAdd}
      onClose={onClose}
      ctaLabel="Save"
      onSubmit={submit}
      submitting={busy}
    >
      <CompanySearchField
        label="Company"
        id={`u1-${spec.key}-company`}
        value={companyName}
        onSelect={(company) => {
          onChoose?.(company);
          setErrors((prev) => ({ ...prev, company: "" }));
        }}
        /* Transcribed: an existing row's company cannot be changed. */
        disabled={companyLocked}
        error={errors.company}
      />

      <SelectField
        className="mt-3.5"
        label="Relation Type"
        labelVariant="field"
        id={`u1-${spec.key}-relation`}
        value={relationType}
        onChange={(e) => {
          setRelationType(e.target.value);
          setErrors((prev) => ({ ...prev, relationType: "" }));
        }}
        error={errors.relationType}
        placeholder="Select a relation type"
        options={spec.relations}
      />

      <Input
        wrapperClassName="mt-3.5"
        label="State"
        id={`u1-${spec.key}-state`}
        required
        value={state}
        onChange={(e) => {
          setState(e.target.value);
          setErrors((prev) => ({ ...prev, state: "" }));
        }}
        error={errors.state}
        placeholder="Enter a state"
      />

      <CountrySelect
        className="mt-3.5"
        label="Country"
        labelVariant="field"
        id={`u1-${spec.key}-country`}
        required
        value={country}
        onChange={(c) => {
          setCountry(c?.code);
          setErrors((prev) => ({ ...prev, country: "" }));
        }}
        error={errors.country}
        placeholder="Select a country"
      />

      {errors.form && (
        <p role="alert" className="mt-3 text-[12px] text-[var(--coral-deep)] font-sans">
          {errors.form}
        </p>
      )}
    </EditDialog>
  );
};

export default RelationFormModal;
